import {
	CHAT_ARTIFACT_TYPE_TO_KIND,
	CHAT_SPEAKING_TYPE_TO_KIND,
	KIND_CONFIG,
	kindConfigForKey,
} from "~/modules/askgvt/artifacts/utils/itemKind";

export type CardMetadata = {
	symbol: string;
	label?: string;
	iconColour?: string;
};

export type ArtifactToolbar = {
	cardType: string;
	symbol: string;
	iconColour?: string;
	/** Omitted for artifact types that can't be rated. */
	ratingSubject?: string;
	saveable: boolean;
};

function cardMetadataForKindKey(kindKey: string): CardMetadata {
	const config = kindConfigForKey(kindKey);
	return {
		symbol: config.symbol,
		label: config.label,
		iconColour: config.colour,
	};
}

export function getCardMetadata(cardType: string): CardMetadata {
	const kindKey = CHAT_SPEAKING_TYPE_TO_KIND[cardType] ?? cardType;
	if (kindKey in KIND_CONFIG) {
		return cardMetadataForKindKey(kindKey);
	}
	return cardMetadataForKindKey("answer");
}

/*
 * Taken from the artifact type rather than the card's label, which is display
 * copy that can be any artifact type the panel hasn't named yet.
 */
const ARTIFACT_RATING_SUBJECT: Partial<Record<string, string>> = {
	video_sources: "these clips",
	deck: "this slide deck",
	csv: "this table",
	document: "this document",
	board: "this board",
};

/** A board already lives on the boards page, so there is nothing to save. */
const UNSAVEABLE_ARTIFACT_TYPES = new Set(["board"]);

export function getArtifactToolbar(artifactType: string): ArtifactToolbar {
	const saveable = !UNSAVEABLE_ARTIFACT_TYPES.has(artifactType);
	const kindKey = CHAT_ARTIFACT_TYPE_TO_KIND[artifactType];
	if (!kindKey) {
		return {
			cardType: artifactType,
			symbol: "chat",
			saveable,
		};
	}
	const meta = cardMetadataForKindKey(kindKey);
	return {
		cardType: meta.label ?? artifactType,
		symbol: meta.symbol,
		iconColour: meta.iconColour,
		ratingSubject: ARTIFACT_RATING_SUBJECT[artifactType],
		saveable,
	};
}
